export function IsNullEmptyOrUndefined(value): boolean {
    if (value === undefined || value === null || value === "") {
        return true;
    } else {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/utils/IsNullEmptyOrUndefined.tsx